<template>
  <div class="super-admin-dashboard__dashboard-widget-stat">
    <span class="super-admin-dashboard__dashboard-widget-stat-content">
      <span class="super-admin-dashboard__dashboard-widget-stat-title">
        {{ title }}
      </span>
      <span class="super-admin-dashboard__dashboard-widget-stat-value">
        {{ value }}
      </span>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>
